<template>
  <v-card class="ml-2 mr-2" height="100%"  style="padding-bottom: 34px">
     <h2 class="text-xs-center">{{$t('dashboard.engagement')}}</h2>
      <v-layout column reverse justify-space-around fill-height class="mt-2 mb-1">
        <v-layout row v-for="{label, ratingText, value, percent, colour} in legend" :key="label" @click="showStudents(label)" style="cursor: pointer;">
          <v-flex xs2>
            <rating-badge :engagement="label"></rating-badge>
          </v-flex>
          <v-flex xs4 class="engagement-value pl-1">
            {{ratingText}}
          </v-flex>
          <v-flex xs2 class="text-xs-right pr-3 bottom-line engagement-value">
            {{value}}
          </v-flex>
          <v-flex xs3 class="text-xs-right bottom-line engagement-value">
            {{percent}}
          </v-flex>
        </v-layout>
     </v-layout>

  </v-card>
</template>

<script>
import { graphRatingColours, ratingLabels, ratingLetter, ratingMapping } from './ratings'
import RatingBadge from '../student/RatingBadge'
import { mapState } from 'vuex'
import { GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT } from '../../store/action-types'

export default {
  name: 'dashboard-engagement-table',
  computed: {
    legend () {
      let ratings
      let percents
      if (this.studentRatingCounts.length === 0) {
        ratings = ['', '', '', '', '', '']
        percents = ratings
      } else {
        ratings = this.studentRatingCounts
        let sum = ratings.reduce((total, current) => total + current, 0)
        if (sum === 0) {
          percents = ['', '', '', '', '', '']
        } else {
          percents = ratings.map(value => (100 * value / sum).toFixed(1) + '%')
        }
      }
      let legendItems = []
      for (let i = 0; i < 6; i++) {
        const ratingText = this.$t('dashboard.ratings.' + ratingLabels[i])
        legendItems.push({label: ratingLetter[i], ratingText, value: ratings[i], percent: percents[i], colour: graphRatingColours[i]})
      }
      return legendItems
    },
    ...mapState({
      studentRatingCounts: state => state.dashboard.studentRatingCounts
    })
  },
  methods: {
    showStudents (engagement) {
      this.$store.dispatch(GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT, ratingMapping[engagement])
      this.$router.push({name: 'Students'})
    }
  },
  components: {
    RatingBadge
  }
}
</script>

<style scoped>
.engagement-value {
  font-size: 20px;
  padding-top: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardEngagementTable.vue